import Overlay from "@/modules/common/components/modals/overlay";
import { InterestProperty } from "@/modules/lead-page/types";
import { Box, Button } from "@mui/material";
import { useState } from "react";
import ActivityHistoryHeader from "./header";
import { ActivityScrollProvider } from "../../../context/activity-scroll-context";
import ActivityTab from "../../activity/activity-tab";
import { InterestActionsProvider } from "../../../context/interest-actions.context";

export default function ActivityHistory({
  interest,
}: {
  interest: InterestProperty;
}) {
  const [open, setOpen] = useState(false);

  const handleModalOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Button
        onClick={handleModalOpen}
        variant="text"
        sx={{
          textTransform: "none",
          textDecoration: "underline",
        }}
      >
        Activity History
      </Button>

      <Overlay
        open={open}
        setOpen={setOpen}
        header={<ActivityHistoryHeader interest={interest} />}
      >
        <Box sx={{ height: "90%" }}>
          <InterestActionsProvider interestUids={[interest.uid]} enabled={open}>
            <ActivityScrollProvider>
              <ActivityTab isHeaderCollapsed={false} />
            </ActivityScrollProvider>
          </InterestActionsProvider>
        </Box>
      </Overlay>
    </>
  );
}
